import { render, staticRenderFns } from "./MandateStep3.vue?vue&type=template&id=dc1d5bd6&scoped=true&"
import script from "./MandateStep3.vue?vue&type=script&lang=js&"
export * from "./MandateStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1d5bd6",
  null
  
)

export default component.exports